import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '../../Components/ComponentButton';
import Modal from '../../Components/ComponentModal';
import { deleteValue } from './Actions';
import T from '../../Locale';
const ComponentModalDelete = ({ id = 0, content = '', onDelete, isDeleting = false }) => (_jsx(Modal, Object.assign({ modalKey: "delete-value", title: T.translate('values.deleteHeadline'), content: content }, { children: _jsx(Button, Object.assign({ isLoading: isDeleting, onClick: () => { onDelete(id); }, isAlert: true }, { children: T.translate('misc.confirm') })) })));
ComponentModalDelete.propTypes = {
    id: PropTypes.number,
    content: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array
    ]),
    isDeleting: PropTypes.bool,
    onDelete: PropTypes.func.isRequired
};
const mapStateToProps = (state) => {
    var _a, _b, _c, _d;
    return ({
        id: (_a = state === null || state === void 0 ? void 0 : state.application) === null || _a === void 0 ? void 0 : _a.modalId,
        content: (_b = state === null || state === void 0 ? void 0 : state.application) === null || _b === void 0 ? void 0 : _b.modalName,
        isDeleting: ((_c = state === null || state === void 0 ? void 0 : state.values) === null || _c === void 0 ? void 0 : _c.currentDeleting) && ((_d = state === null || state === void 0 ? void 0 : state.application) === null || _d === void 0 ? void 0 : _d.modalId) && state.values.currentDeleting === state.application.modalId
    });
};
const mapDispatchToProps = (dispatch) => ({ onDelete: (id) => { dispatch(deleteValue(id)); } });
export default connect(mapStateToProps, mapDispatchToProps)(ComponentModalDelete);
